<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-list-item @mouseover="showButton = true"
                 @mouseleave="showButton = false"
                 :class="[!notification.viewed ? 'kbLight' : '']">
        <v-list-item-content>
            <v-list-item-title v-html="notification.app ? notification.app.name : 'General'"></v-list-item-title>
            <v-list-item-subtitle v-html="notification.message"></v-list-item-subtitle>
        </v-list-item-content>

        <v-fade-transition>
            <v-list-item-action v-show="showButton && !notification.viewed">
                <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                        <v-btn icon
                               :loading="loading"
                               v-on="on"
                               @click="handleClick">
                            <v-icon color="kbDarkBlueText">
                                remove_red_eye
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Marcar como visto</span>
                </v-tooltip>
            </v-list-item-action>
        </v-fade-transition>
    </v-list-item>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      showButton: false
    }
  },
  methods: {
    async handleClick () {
      try {
        this.loading = true
        await this.$store.dispatch('markAppNotificationAsViewed', this.notification._id)
        this.notification.viewed = true
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  props: ['notification']
}
</script>
